import React, { useState, useEffect } from "react";

const HistorySidebar = ({setNewQuery, retriggerHistoryProp, userIdProp}) => {
  const [historyData, setHistoryData] = useState({});
  const [collapsed, setCollapsed] = useState(true);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const token = localStorage.getItem("google_token");
        //const response = await fetch("http://localhost:7169/Transcript/GetHistory?userId=girinath19", {
        const response = await fetch("https://plato-vm.westus.cloudapp.azure.com:5001/Transcript/GetHistory?userId="+userIdProp, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`
            }});
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setHistoryData(data);
      } catch (error) {
        console.error("Error fetching history:", error);
      }
    };

    if(userIdProp)
        fetchHistory();
  }, [retriggerHistoryProp, userIdProp]);

  const expandMenu = () => {
    setCollapsed((prev) => !prev);
  };

  const callSetNewQuery = (id, title, backgroundUrl) => {
    setNewQuery(id, title, backgroundUrl);
    setCollapsed(true);
  }

  return (
    <>
      {/* ☰ Menu Button */}
      <button
        onClick={expandMenu}
        style={{
          position: "fixed",
          top: "10px",
          left: collapsed ? "10px" : "240px", // Moves to top-right when expanded
          zIndex: "1000",
          cursor: "pointer",
          fontSize: "24px",
          background: "transparent",
          border: "none",
          color: "white",
          transition: "left 0.3s ease",
        }}
      >
        ☰
      </button>

      {/* Sidebar */}
      <div
        style={{
          position: "fixed",
          left: "0",
          top: "0",
          height: "100vh",
          width: collapsed ? "0px" : "250px",
          background: collapsed ? "transparent" : "rgba(30, 30, 30, 0.9)",
          color: "white",
          transition: "width 0.3s ease",
          overflowX: "hidden",
          boxShadow: collapsed ? "none" : "2px 0 5px rgba(0,0,0,0.3)",
          padding: collapsed ? "0" : "10px",
        }}
      >
        {/* History Content (Only Visible When Expanded) */}
        {!collapsed && (
          <div style={{ marginTop: "10px", overflowY: "auto", height: "calc(100vh - 50px)" }}>
            {Object.entries(historyData).map(([category, items]) => (
              <div key={category} style={{ marginBottom: "10px" }}>
                <div style={{ fontWeight: "bold", padding: "5px 0", color: "#aaa" }}>{category}</div>
                <ul style={{ listStyleType: "none", paddingLeft: "10px" }}>
                  {items.length === 0 ? (
                    <li style={{ color: "#888" }}>No entries</li>
                  ) : (
                    items.map((item) => (
                      <li key={item.id} style={{ padding: "5px 0", cursor: "pointer" }} onClick={() => callSetNewQuery(item.id, item.title, item.backgroundUrl)}>
                        {item.title}
                      </li>
                    ))
                  )}
                </ul>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default HistorySidebar;
